/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import { $getSelection, $isNodeSelection, COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand } from "lexical";
import { useEffect } from "react";
import { $isSlidVideoNode, SlidVideoNode } from "components/NewEditor/nodes/SlidVideoNode";

export const FOCUS_VIDEO_DUMMY_TEXTAREA_COMMAND: LexicalCommand<void> = createCommand("FOCUS_VIDEO_DUMMY_TEXTAREA_COMMAND");

export function SlidVideoNodePlugin(): null {
  const [editor] = useLexicalComposerContext();

  function $getSlidVideoNodeInSelection(): SlidVideoNode | null {
    const selection = $getSelection();
    if (!$isNodeSelection(selection)) {
      return null;
    }
    const nodes = selection.getNodes();
    const node = nodes[0];
    return $isSlidVideoNode(node) ? node : null;
  }

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        FOCUS_VIDEO_DUMMY_TEXTAREA_COMMAND,
        () => {
          const slidVideoNode = $getSlidVideoNodeInSelection();
          if (slidVideoNode) {
            const slidVideoNodeKey = slidVideoNode.getKey();
            const slidVideoNodeElement = editor.getElementByKey(slidVideoNodeKey);
            if (slidVideoNodeElement) {
              const input = slidVideoNodeElement.querySelector("textarea");
              if (input) {
                input.focus();
              }
            }
          }
          return true;
        },
        COMMAND_PRIORITY_EDITOR
      )
    );
  }, [editor]);
  return null;
}
